module.exports = __webpack_public_path__ + "static/bg2-1c2aa0527e4adea492011c080678874e.jpg";